import React from 'react';

import PropTypes from 'prop-types';
import Select from '@tds/core-select';

import { useLocalizedStringsContext } from '../../../../../context/LocalizedStringsContext';

const FilterByProduct = ({ filters, setFilters }) => {
  const localizedStrings = useLocalizedStringsContext();
  const {
    ORDERS: { filterByProduct, ProductPlaceholder, ProductFilters }
  } = localizedStrings;
  return (
    <div style={{ margin: '1rem 2rem', gridArea: 'f-product' }}>
      <Select
        label={filterByProduct}
        placeholder={ProductPlaceholder}
        options={ProductFilters}
        defaultValue=""
        value={filters.iotProductSelected}
        onChange={e =>
          setFilters({ ...filters, iotProductSelected: e.target.value })
        }
      />
    </div>
  );
};

FilterByProduct.propTypes = {
  filters: PropTypes.objectOf(PropTypes.shape({})).isRequired,
  setFilters: PropTypes.func.isRequired
};

export default FilterByProduct;
